import { Injectable } from '@angular/core';
import { TranslocoLoader } from '@ngneat/transloco';
import { of } from 'rxjs';
import { I18nConstant } from './core/constants/i18n.constant';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation(lang: string) {
    return of(I18nConstant[lang] || {});
  }
}
